import { render, staticRenderFns } from "./MetodoPHD.vue?vue&type=template&id=10ccc8e7&scoped=true"
import script from "./MetodoPHD.vue?vue&type=script&lang=js"
export * from "./MetodoPHD.vue?vue&type=script&lang=js"
import style0 from "./MetodoPHD.vue?vue&type=style&index=0&id=10ccc8e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ccc8e7",
  null
  
)

export default component.exports